/** Active boards hide rows with deleted_at set. Trash asks for the opposite. */

export const ACTIVE_TICKET_DELETED_FILTER = {
  "deleted_at@is": null,
} as const;

/** PostgREST via ra-data-postgrest: `deleted_at@not` + `is.null` → `not.is.null`. */
export const DELETED_TICKETS_FILTER = {
  "deleted_at@not": "is.null",
} as const;

export const withActiveTicketsFilter = (
  filter: Record<string, unknown> | undefined,
) => {
  const next = { ...(filter ?? {}) };
  const specifiesDeleted = Object.keys(next).some(
    (key) => key === "deleted_at" || key.startsWith("deleted_at@"),
  );
  if (specifiesDeleted) return next;
  return { ...next, ...ACTIVE_TICKET_DELETED_FILTER };
};
